module.exports = __webpack_public_path__ + "img/company45.2440e14c.png";